const IconViga = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="6" width="52" height="10" fill="currentColor" />
    <rect x="27" y="16" width="10" height="32" fill="currentColor" />
    <rect x="6" y="48" width="52" height="10" fill="currentColor" />
  </svg>
);

const IconVarilla = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="28" width="52" height="8" rx="4" fill="currentColor" />
    <rect x="13" y="20" width="5" height="24" rx="2" fill="currentColor" opacity="0.7" />
    <rect x="24" y="20" width="5" height="24" rx="2" fill="currentColor" opacity="0.7" />
    <rect x="35" y="20" width="5" height="24" rx="2" fill="currentColor" opacity="0.7" />
    <rect x="46" y="20" width="5" height="24" rx="2" fill="currentColor" opacity="0.7" />
  </svg>
);

const IconAngulo = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="8" width="10" height="48" fill="currentColor" />
    <rect x="8" y="48" width="48" height="10" fill="currentColor" />
  </svg>
);

const IconPTR = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="8" width="48" height="48" rx="2" stroke="currentColor" strokeWidth="10" fill="none" />
  </svg>
);

const IconTubo = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="24" stroke="currentColor" strokeWidth="10" fill="none" />
    <circle cx="32" cy="32" r="10" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.4" />
  </svg>
);

const IconMoiten = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="6" width="52" height="8" fill="currentColor" />
    <line x1="10" y1="14" x2="24" y2="50" stroke="currentColor" strokeWidth="7" strokeLinecap="round" />
    <line x1="54" y1="14" x2="40" y2="50" stroke="currentColor" strokeWidth="7" strokeLinecap="round" />
    <rect x="6" y="50" width="52" height="8" fill="currentColor" />
  </svg>
);

const IconLaminaTecho = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 48 Q10 32 16 32 Q22 32 28 48 Q34 32 40 32 Q46 32 52 48 L60 48 L60 54 L4 54 Z" fill="currentColor" />
    <rect x="4" y="10" width="56" height="8" fill="currentColor" opacity="0.5" />
  </svg>
);

const IconLaminaNegra = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="18" width="56" height="28" fill="currentColor" />
    <rect x="4" y="18" width="56" height="4" fill="currentColor" opacity="0.5" />
    <rect x="4" y="42" width="56" height="4" fill="currentColor" opacity="0.5" />
  </svg>
);

const IconSolera = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="22" width="56" height="20" fill="currentColor" />
    <line x1="4" y1="32" x2="60" y2="32" stroke="rgba(0,0,0,0.2)" strokeWidth="2" />
  </svg>
);

const IconCuadro = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="10" width="44" height="44" fill="currentColor" />
    <rect x="18" y="18" width="28" height="28" fill="var(--dark-3)" />
    <rect x="10" y="10" width="44" height="44" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
);

const IconEtc = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="14" cy="32" r="7" fill="currentColor" />
    <circle cx="32" cy="32" r="7" fill="currentColor" />
    <circle cx="50" cy="32" r="7" fill="currentColor" />
  </svg>
);

const IconLaminaAnti = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="18" width="56" height="28" fill="currentColor" />
    <circle cx="18" cy="28" r="4" fill="var(--dark-3)" opacity="0.7" />
    <circle cx="32" cy="28" r="4" fill="var(--dark-3)" opacity="0.7" />
    <circle cx="46" cy="28" r="4" fill="var(--dark-3)" opacity="0.7" />
    <circle cx="18" cy="40" r="4" fill="var(--dark-3)" opacity="0.7" />
    <circle cx="32" cy="40" r="4" fill="var(--dark-3)" opacity="0.7" />
    <circle cx="46" cy="40" r="4" fill="var(--dark-3)" opacity="0.7" />
  </svg>
);

const IconMalla = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="4" y1="16" x2="60" y2="16" stroke="currentColor" strokeWidth="4" />
    <line x1="4" y1="32" x2="60" y2="32" stroke="currentColor" strokeWidth="4" />
    <line x1="4" y1="48" x2="60" y2="48" stroke="currentColor" strokeWidth="4" />
    <line x1="16" y1="8" x2="16" y2="56" stroke="currentColor" strokeWidth="4" />
    <line x1="32" y1="8" x2="32" y2="56" stroke="currentColor" strokeWidth="4" />
    <line x1="48" y1="8" x2="48" y2="56" stroke="currentColor" strokeWidth="4" />
  </svg>
);

const IconAlambre = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="22" stroke="currentColor" strokeWidth="5" fill="none" />
    <circle cx="32" cy="32" r="12" stroke="currentColor" strokeWidth="3" fill="none" opacity="0.6" />
    <circle cx="32" cy="32" r="4" fill="currentColor" opacity="0.4" />
    <line x1="32" y1="10" x2="32" y2="54" stroke="currentColor" strokeWidth="2" opacity="0.3" />
    <line x1="10" y1="32" x2="54" y2="32" stroke="currentColor" strokeWidth="2" opacity="0.3" />
  </svg>
);

const products = [
  { name: 'Viga', desc: 'Viga estructural de acero para construcción resistente.', Icon: IconViga },
  { name: 'Varilla', desc: 'Varilla corrugada para refuerzo en concreto armado.', Icon: IconVarilla },
  { name: 'Angulos', desc: 'Ángulo de acero en diversas medidas estándar.', Icon: IconAngulo },
  { name: 'PTR', desc: 'Perfil tubular rectangular y cuadrado de acero.', Icon: IconPTR },
  { name: 'Tubo', desc: 'Tubo redondo de acero negro y galvanizado.', Icon: IconTubo },
  { name: 'Moiten', desc: 'Canal estructural de acero tipo Moiten.', Icon: IconMoiten },
  { name: 'Lámina p/ Techo', desc: 'Lámina acanalada galvanizada para techos.', Icon: IconLaminaTecho },
  { name: 'Lámina Negra', desc: 'Lámina de acero negro en calibres estándar.', Icon: IconLaminaNegra },
  { name: 'Soleras', desc: 'Barra plana de acero en distintas medidas.', Icon: IconSolera },
  { name: 'Cuadros', desc: 'Barra cuadrada de acero macizo.', Icon: IconCuadro },
  { name: 'Lámina Antiderrapante', desc: 'Lámina de acero con superficie antideslizante para pisos y rampas.', Icon: IconLaminaAnti },
  { name: 'Malla Electrosoldada', desc: 'Malla de alambre soldado para refuerzo de losas y cimentaciones.', Icon: IconMalla },
  { name: 'Alambre Recocido', desc: 'Alambre suave para amarre de varilla en estructuras de concreto.', Icon: IconAlambre },
];

export default function Products() {
  return (
    <section id="productos" className="products">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Lo que ofrecemos</p>
          <h2 className="section-title light">Nuestros Productos</h2>
          <div className="section-divider" />
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        <div className="products-grid">
          {products.map(({ name, desc, Icon }) => (
            <div key={name} className="product-card">
              <div className="product-icon">
                <Icon />
              </div>
              <h3 className="product-name">{name}</h3>
              <p className="product-desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="strip" style={{ marginTop: '2px' }}>
        <div className="strip-inner">
          <span className="strip-label">Nota</span>
          <span className="strip-text">
            También manejamos materiales adicionales — consulta disponibilidad y precios directamente con nosotros.
          </span>
        </div>
      </div>
    </section>
  );
}
